import React, { FC, useEffect, useState } from "react";
import useCountTime from "~src/hooks/useCountTime";
import { TopIconType } from "~src/service/answer/answer";
import { Image } from "antd-mobile";
import styles from "./index.module.less";
import { question_countdown, question_fail, question_success, question_warn, wait_fail } from "~src/assets/images/answerGame";


interface TopIconCallbackProps {
  topIcon: TopIconType;
  timer?: number;
  handleComplete: () => void;
}
const MaskContentTopIcon: FC<TopIconCallbackProps> = ({ topIcon,timer= 5, handleComplete }) => {
  const [remainingTime, setRemainingTime] = useState<string>("");
  const [remainingMinutes, setRemainingMinutes] = useState<number>(timer);
  const handleTick = (remainingTime: string) => {
    setRemainingTime(remainingTime);
  };
  const handleCompleter = () => {
    handleComplete()
  }
  const { start, stop, setCountdown } = useCountTime({
    remainingMinutes,
    setRemainingMinutes,
    onTick: handleTick,
    onCountdown: handleCompleter,
  })
  useEffect(() => {
    if (topIcon === "question_countdown") {
      start()
      setCountdown(timer)
    }
    return () => {
      stop()
    }
  }, [ timer])
  const TopIconCallback: Record<TopIconType, () => JSX.Element> = {
    question_countdown: () => {
      return <div className={styles["mask-conts"]}>
         <Image className={styles.mask_top_icon} src={question_countdown}></Image>
        <div className={styles["mask-conts-txt"]}>{remainingTime}</div>
      </div>

    },
    wait_fail: () => {
      return <Image className={styles.mask_top_icon} src={wait_fail}></Image>
    },
    question_success: () => {
      return <Image className={styles.mask_top_icon} src={question_success}></Image>
    },
    question_fail: () => {
      return <Image className={styles.mask_top_icon} src={question_fail}></Image>
    },
    question_warn: () => {
      return <Image className={styles.mask_top_icon} src={question_warn}></Image>
    }
  }
  return TopIconCallback[topIcon]()
}
export default React.memo(MaskContentTopIcon)